export const AuthMethodTypes = {
  URL_AUTH: 'URL_AUTH',
  API_KEY: 'API_KEY',
  BASIC_AUTH: 'BASIC_AUTH',
  OAUTH: 'OAUTH',
  ALLOW_ALL: 'ALLOW_ALL',
};

export const authMethodsAsSelectOptions = [
  {
    value: AuthMethodTypes.URL_AUTH,
    descId: `AUTHENTICATION_METHOD_${AuthMethodTypes.URL_AUTH}_DESCRIPTION`,
    labelId: `ALLOW_TRIGGER_${AuthMethodTypes.URL_AUTH}`, // 'URL Authentication',
  },
  {
    value: AuthMethodTypes.BASIC_AUTH,
    descId: `AUTHENTICATION_METHOD_${AuthMethodTypes.BASIC_AUTH}_DESCRIPTION`,
    labelId: `ALLOW_TRIGGER_${AuthMethodTypes.BASIC_AUTH}`, // 'Basic Authentication',
  },
  {
    value: AuthMethodTypes.API_KEY,
    descId: `AUTHENTICATION_METHOD_${AuthMethodTypes.API_KEY}_DESCRIPTION`,
    labelId: `ALLOW_TRIGGER_${AuthMethodTypes.API_KEY}`, // 'API Key',
  },
  {
    value: AuthMethodTypes.OAUTH,
    descId: `AUTHENTICATION_METHOD_${AuthMethodTypes.OAUTH}_DESCRIPTION`,
    labelId: `ALLOW_TRIGGER_${AuthMethodTypes.OAUTH}`, // 'OAuth',
  },
  {
    value: AuthMethodTypes.ALLOW_ALL,
    descId: `AUTHENTICATION_METHOD_${AuthMethodTypes.ALLOW_ALL}_DESCRIPTION`,
    labelId: `ALLOW_TRIGGER_${AuthMethodTypes.ALLOW_ALL}`, // 'Allow all methods',
  },
];

export function mapAuthTypeForBackend(authType) {
  switch (authType) {
    case AuthMethodTypes.BASIC_AUTH:
      return 'BASIC';

    case AuthMethodTypes.URL_AUTH:
      return 'URL';

    case AuthMethodTypes.ALLOW_ALL:
      return 'ANY';

    default:
      return authType || 'URL';
  }
}

export function mapAuthMethod(authMethod) {
  switch (authMethod) {
    case 'BASIC':
      return 'BASIC_AUTH';

    case 'URL':
      return 'URL_AUTH';

    case 'ANY':
      return 'ALLOW_ALL';

    default:
      return authMethod;
  }
}
